import videojs from "video.js";

const defaults = {
  lang: "en",
};

const registerPlugin = videojs.registerPlugin || videojs.plugin;

const errors = {
  fr: {
    1: "Vous avez interrompu la lecture du média",
    2: "Une erreur de réseau a provoqué l'échec du téléchargement de média",
    3: "La lecture du média a été interrompue en raison d'un problème de corruption ou parce que les médias utilisés ne sont pas compatibles avec votre navigateur.",
    4: "Les médias n'ont pas pu être chargés, soit parce que le serveur ou le réseau a échoué, soit parce que le format n'est pas pris en charge.",
    5: "Les médias sont chiffrés et nous n'avons pas les clés pour le décrypter.",
  },
  en: {
    1: "You aborted the media playback",
    2: "A network error caused the media download to fail part-way.",
    3: "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.",
    4: "The media could not be loaded, either because the server or network failed or because the format is not supported.",
    5: "The media is encrypted and we do not have the keys to decrypt it.",
  },
};

/**
 * An EasyBroadcast video.js plugin.
 *
 * Errors translations
 *
 */
function errorsTranslate(options = defaults) {
  this.on("error", () => {
    if (this.error().code && this.error().code > 0 && this.error().code < 6) {
      const display = this.getChild("errorDisplay");
      display.el_.innerHTML = `<p class="vjs-modal-dialog-description vjs-control-text" id="Arryadia-player_component_426_description">This is a modal window.</p><div class="vjs-modal-dialog-content" role="document">${
        errors[options.lang][this.error().code]
      }</div>`;
    }
  });
}

registerPlugin("errorsTranslate", errorsTranslate);

errorsTranslate.VERSION = "0.9";

export default errorsTranslate;



// WEBPACK FOOTER //
// ./src/js/videoJSExtensions/videojs-errors.js